import React from 'react';
import { Link } from 'react-router-dom';
import { Nav, Navbar, NavDropdown } from 'react-bootstrap';
import headerBarStyles from '../../css/Header.module.css';
import domesticStyles from './HeaderDomestic.module.css';
import '../../../pages/css/domesticTheme.css';
import logo from '../../../assets/images/logo.png';
import dropdownArrow from '../../../assets/images/op1.png';
import { useDomesticHeaderSpacer } from './useDomesticHeaderSpacer';

/**
 * Guest (logged-out) domestic Ohana portal shell.
 * Same public routes as the classic guest header.
 */
export default function DomesticGuestHeader({
  user,
  location,
  getPathDetails,
  changeLanguage,
  onLogin,
  t,
}) {
  const { headerRef, spacerStyle } = useDomesticHeaderSpacer();
  const pathname = (location && location.pathname) || '';
  const showDetention =
    user.continent_code === 'AS' ||
    process.env.REACT_APP_STAGE !== 'production';
  const showInformationCenter =
    user.continent_code === 'AS' ||
    process.env.REACT_APP_STAGE !== 'production';
  const showContainerSearch = user.vgm !== 'true';

  const isContainerSearchActive =
    getPathDetails('/search') ||
    getPathDetails('/containerList') ||
    getPathDetails('/') ||
    pathname === '/';

  const navTitleClass = (active) =>
    active ? headerBarStyles.titleText_Bold : headerBarStyles.titleText;

  return (
    <>
      <header
        ref={headerRef}
        className={[domesticStyles.shell, 'domestic-design-scope'].join(' ')}
      >
        <Navbar
          bg="white"
          expand="lg"
          className={domesticStyles.domesticNavbarMain}
        >
          <Navbar.Brand className="d-flex align-items-center py-0 me-0 me-lg-2">
            <Nav.Link
              as={Link}
              to="/"
              href="/"
              className={domesticStyles.brandLink}
            >
              <img
                className={domesticStyles.logo}
                height="44"
                src={logo}
                alt="Matson"
              />
            </Nav.Link>
          </Navbar.Brand>
          <Navbar.Toggle
            aria-controls="ohana-domestic-guest-nav"
            className={domesticStyles.toggle}
          />
          <Navbar.Collapse
            id="ohana-domestic-guest-nav"
            className={`justify-content-lg-center align-items-lg-center flex-grow-1 ${domesticStyles.collapseNav}`}
          >
            <div
              className={`d-flex flex-column flex-lg-row flex-wrap align-items-lg-center justify-content-lg-center flex-lg-grow-1 gap-1 ${domesticStyles.primaryNav}`}
            >
              {showContainerSearch ? (
                <Link to="/search" className={headerBarStyles.navLink}>
                  <p className={navTitleClass(isContainerSearchActive)}>
                    {t('header.containerSearch')}
                  </p>
                </Link>
              ) : null}
              <Link to="/registration" className={headerBarStyles.navLink}>
                <p
                  className={navTitleClass(getPathDetails('/registration'))}
                >
                  {t('header.registration')}
                </p>
              </Link>
              {showDetention ? (
                <Link
                  to="/detentionChargeCalculator"
                  className={headerBarStyles.navLink}
                >
                  <p
                    className={navTitleClass(
                      getPathDetails('/detentionChargeCalculator')
                    )}
                  >
                    {t('header.detention')}
                  </p>
                </Link>
              ) : null}
              {showInformationCenter ? (
                <Link
                  to="/informationCenter"
                  className={headerBarStyles.navLink}
                >
                  <p
                    className={navTitleClass(
                      getPathDetails('/informationCenter')
                    )}
                  >
                    {t('informationCenter.txtTitle')}
                  </p>
                </Link>
              ) : null}
            </div>
            <div
              className={`ms-lg-3 mt-2 mt-lg-0 ${domesticStyles.profileSlot}`}
            >
              <div className={headerBarStyles.collasibleNavDropdownDiv}>
                <NavDropdown
                  alignRight
                  title={
                    <span className={headerBarStyles.collasibleNavDropdownSpan}>
                      <i
                        className={[
                          'fa fa-user-circle-o',
                          headerBarStyles.dropdownUserIcon,
                        ].join(' ')}
                      />
                      Guest
                      <img
                        src={dropdownArrow}
                        className={headerBarStyles.dropdownArrow}
                        alt="arrow"
                      />
                    </span>
                  }
                  id="header-nav-dropdown"
                  className={headerBarStyles.collasibleNavDropdown}
                >
                  <NavDropdown.Item
                    eventKey="5"
                    onClick={() => changeLanguage('en')}
                  >
                    English
                  </NavDropdown.Item>
                  <NavDropdown.Item
                    eventKey="6"
                    onClick={() => changeLanguage('zh')}
                  >
                    Mandarin
                  </NavDropdown.Item>
                  <NavDropdown.Divider />
                  <NavDropdown.Item eventKey="8" onClick={onLogin}>
                    Login
                  </NavDropdown.Item>
                </NavDropdown>
              </div>
            </div>
          </Navbar.Collapse>
        </Navbar>
      </header>
      {/* Guest routes are intl pages with margin-top: 80px — cancel via spacer */}
      <div
        className={`${domesticStyles.spacer} ${domesticStyles.spacerHeightMain} ${domesticStyles.spacerCancelLegacyOffset}`}
        style={spacerStyle}
        aria-hidden
      />
    </>
  );
}
